import React from "react";
import s from "../checklists.less";
import { useTranslation } from "react-i18next";
import { dateUTC } from "../helper";

interface IProps {
  id: string;
  createdAt: string;
  documentName: string;
  dealerName: string;
}

const HeaderInfo: React.FC<IProps> = ({
  id,
  createdAt,
  documentName,
  dealerName,
}) => {
  const { t } = useTranslation();
  return (
    <div className={s.mainHeader}>
      <div>
        <div className={s.headerTitle}>
          {t(`pkd_checklists.table.createdAt`)}
        </div>
        <div className={s.headerData}>{dateUTC(createdAt)}</div>
      </div>
      <div>
        <div className={s.headerTitle}>
          {t(`pkd_checklists.table.document_number`)}
        </div>
        <div className={s.headerData}>{id}</div>
      </div>
      <div>
        <div className={s.headerTitle}>{t("pkd_checklists.table.name")}</div>
        <div className={s.headerData}>{documentName}</div>
      </div>
      <div>
        <div className={s.headerTitle}>{t(`pkd_checklists.table.dealer`)}</div>
        <div className={s.headerData}>{dealerName}</div>
      </div>
    </div>
  );
};

export default HeaderInfo;
